const getters = {
  token: state => state.user.token,
  name: state => state.user.name,
  nickname: state => state.user.nickname,
  admintoken: state => state.adminuser.admintoken,
  adminname: state => state.adminuser.adminname,
  sidebar: state => state.app.sidebar,
  device: state => state.app.device
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js